import Factory from 'factories/all';

export default function createEmailSendFailureItem(failure, agent) {
  return Factory.build('EmailSendFailureItem', {
    content: failure.content,
  });
}
